import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompactTimeline, Timeline } from '../../../interfaces/timeline';
import { MatchingPeriod } from '../../../interfaces/matchingPeriod';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-timeline-card',
    imports: [CommonModule],
    templateUrl: './timeline-card.component.html',
    styleUrl: './timeline-card.component.scss'
})
export class TimelineCardComponent {
  @Input() compactTimeline!: CompactTimeline;
  @Input() currentPeriod!: MatchingPeriod | null;
  @Input() nextPeriod!: MatchingPeriod | null;
  @Input() expanded!: boolean;

  ngOnInit(): void {}
}
